module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-latin366.d6c0bd0.woff2";